import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ScreenService} from '@app/core';
import {DocumentType} from '@app/shared';
import {UploadFormData} from '../doc-modal/doc-modal.component';

@Component({
  selector: 'app-create-doc-form-card',
  standalone: false,

  templateUrl: './create-doc-form-card.component.html',
  styleUrl: './create-doc-form-card.component.less'
})
export class CreateDocFormCardComponent {

  @Input() onlyReturnFiles: boolean = false;
  @Input() disabled: boolean = false;
  @Input() documentTypes!: DocumentType[];
  @Input() form!: UploadFormData

  @Output() deleteEvent = new EventEmitter<void>();

  constructor(public screenService: ScreenService) {
  }

  emitDeleteEvent() {
    this.deleteEvent.emit();
  }

}
